import React, { useEffect, useState, useRef } from 'react';
import './LogoLoader.css';
// Import your logo image (adjust the path as needed)
import logoImage from '../images/irclogo.webp';

const LogoLoader = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const loaderRef = useRef(null);

  useEffect(() => {
    const node = loaderRef.current;

    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => setShowLoader(false), 1000);
    }, 2000); // 2 seconds

    // Preload animations
    if (node) {
      node.style.willChange = 'transform, opacity';
    }

    return () => {
      clearTimeout(timer);
      if (node) {
        node.style.willChange = 'auto';
      }
    };
  }, []);

  if (!showLoader) return null;

  return (
    <div
      className={`irc-loader-container ${isExiting ? 'fade-out' : ''}`}
      ref={loaderRef}
    >
      <div className="irc-loader">
        <div className="logo-wrapper">
          {/* Use your logo image instead of text letters */}
          <img 
            src={logoImage} 
            alt="Logo" 
            className="logo-image"
          />
        </div>
        <div className="progress-track">
          <div className="progress-fill"></div>
        </div>
      </div>
    </div>
  );
};

export default LogoLoader;











// import React, { useEffect, useState, useRef } from 'react';
// import './LogoLoader.css';

// const LogoLoader = () => {
//   const [showLoader, setShowLoader] = useState(true);
//   const [isExiting, setIsExiting] = useState(false);
//   const loaderRef = useRef(null);

//   useEffect(() => {
//     const node = loaderRef.current; // ✅ copy ref here

//     const timer = setTimeout(() => {
//       setIsExiting(true);
//       setTimeout(() => setShowLoader(false), 1000);
//     }, 2000); // 2 seconds

//     // Preload animations
//     if (node) {
//       node.style.willChange = 'transform, opacity';
//     }

//     return () => {
//       clearTimeout(timer);
//       if (node) {
//         node.style.willChange = 'auto';
//       }
//     };
//   }, []);


//   if (!showLoader) return null;

//   return (
//     <div
//       className={`irc-loader-container ${isExiting ? 'fade-out' : ''}`}
//       ref={loaderRef}
//     >
//       <div className="irc-loader">
//         <div className="logo-wrapper">
//           <span className="letter i">i</span>
//           <span className="letter r">R</span>
//           <span className="letter c">C</span>
//         </div>
//         <div className="progress-track">
//           <div className="progress-fill"></div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LogoLoader;













